export type OutgoingIdentity = {id:string;nonce?:string;conversationId?:string;parentId:string;sendState?:'sending'|'failed'|'sent'};
// Reconcile acknowledgements and live events using the same retry nonce.
// An old history snapshot must never erase an unacknowledged local message.
export function mergeOutgoing<T extends OutgoingIdentity>(rows:T[],pending:Map<string,T>,conversationId:string,parentId=''):T[]{
  const confirmed=rows.filter(row=>!row.sendState);
  for(const row of confirmed){
    for(const [nonce,item] of pending){
      if(item.conversationId===conversationId&&(row.nonce===nonce||row.id===item.id))pending.delete(nonce);
    }
  }
  const additions=[...pending.values()].filter(item=>item.conversationId===conversationId&&item.parentId===parentId);
  return [...confirmed,...additions];
}
